import { useMemo } from 'react';
import { RATING_LEVELS } from '../constants/cardConstants';

export const useRatingInfo = (rating = 0) => {
  return useMemo(() => {
    if (rating >= RATING_LEVELS.legend.min) return RATING_LEVELS.legend;
    if (rating >= RATING_LEVELS.master.min) return RATING_LEVELS.master;
    if (rating >= RATING_LEVELS.veteran.min) return RATING_LEVELS.veteran;
    return RATING_LEVELS.novice;
  }, [rating]);
};